export default __webpack_public_path__ + "static/media/headerIcon.ed1a7d81.svg";